module.exports = __webpack_public_path__ + "static/media/HCMM283.62886b31.jpg";